import { InjectionToken } from '@angular/core';

/**
 * Absolute base URL of the external viewer app (no trailing slash), e.g. https://external.dev.app-context.com
 */
export const EXTERNAL_VIEWER_BASE_URL = new InjectionToken<string>(
	'EXTERNAL_VIEWER_BASE_URL',
);
